module.exports = __webpack_public_path__ + "static/media/992059.e94c6eaf.png";